/* eslint-disable import/prefer-default-export */
import styled, { keyframes, css } from 'styled-components';

// ---------------------------------------------------------------------------
// Skeleton — placeholder de carregamento POR BLOCO.
//
// Nasceu no dashboard de vendas a prazo (handoff 0084), mas é primitivo de DS:
// vive aqui, não na pasta da tela. A regra que ele codifica: cada bloco carrega
// e falha sozinho — NUNCA spinner de página inteira cobrindo a tela toda
// (`components/Loading`), que faz o operador esperar o mais lento de todos.
//
// Uso:
//   <SkeletonBar $h={30} />            barra de valor de tile
//   <SkeletonBar $h={44} $w="60%" />   linha de tabela
//   <SkeletonStack $rows={4} $h={44} /> bloco de linhas com respiro
// ---------------------------------------------------------------------------

const shimmer = keyframes`
   from { background-position: -320px 0; }
   to   { background-position: 320px 0; }
`;

export const skeletonCss = css`
   background-image: linear-gradient(90deg, #eee, #f7f7f7, #eee);
   background-size: 320px 100%;
   background-repeat: repeat-x;
   animation: ${shimmer} 1.1s linear infinite;

   /* Movimento é decorativo: quem pediu menos animação vê o bloco parado. */
   @media (prefers-reduced-motion: reduce) {
      animation: none;
   }
`;

export const SkeletonBar = styled.span.attrs({
   'aria-hidden': 'true',
})`
   display: block;
   width: ${({ $w }) => $w ?? '100%'};
   height: ${({ $h }) => `${$h ?? 14}px`};
   border-radius: ${({ $r }) => `${$r ?? 6}px`};
   ${skeletonCss}
`;

export const SkeletonStack = styled.div.attrs({
   role: 'status',
   'aria-busy': 'true',
   'aria-live': 'polite',
})`
   display: grid;
   gap: ${({ $gap }) => `${$gap ?? 8}px`};
`;
